module.exports =
{

  _init: function ()
  {
    this.onConfirm()
  },

  onConfirm: function ()
  {

    $('.js-confirm').not('.js-ignore').click(function ()
    {

      APPLICATION._APPLICATION.customModal(
        "/wifi-guarantee/terms?bedrooms=" + $("#bedrooms").val(),
        "WifiGuarantee",
        "terms"
      );

    }).addClass('js-ignore')

  },

}